<template>
    <Breadcrumbs
        main="Liste des utilisateurs"
        mains="Liste des utilisateurs"
        title="Paramètres"
    />
    <div class="container-fluid">
        <div class="row">
            <UserList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue';
const UserList = defineAsyncComponent(
    () => import('@/components/theme/user/UserList.vue'),
);
</script>